export const parseAndFormatDimension = (dimension) => {
    if (typeof dimension === 'number') {
        return `${dimension}px`;
    }
    return dimension;
};